import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
    // Convert NgbDateStruct to String (dd-MM-yyyy)
    format(date: NgbDateStruct | null): string {
        return date ? `${this.pad(date.day)}-${this.pad(date.month)}-${date.year}` : '';
    }

    // Convert String (dd-MM-yyyy) to NgbDateStruct
    parse(value: string): NgbDateStruct | null {
        if (!value) return null;
        const parts = value.split('-');
        return parts.length === 3
            ? { day: +parts[0], month: +parts[1], year: +parts[2] }
            : null;
    }

    private pad(number: number): string {
        return number < 10 ? `0${number}` : `${number}`;
    }
}
